<template>
    <div>
        <div ref="trigger">
        <slot>
            <ui-button 
                :disabled="disabled"
                icon="group" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Team</ui-button>
        </slot>
        </div>
        <ui-popover ref="assignPopover" :trigger="$refs.trigger" v-show="!disabled">
            <div style="width:100%; background:#f8f8f8; padding: .8rem 1rem;">Team</div>
            <div style="padding: 1rem; width: 15rem;">
                <ui-select 
                    has-search
                    placeholder="Select team" 
                    v-model="selected" 
                    :options="teams" 
                    :keys="{ label: 'name', value: 'id' }"
                ></ui-select>
                <ui-button :loading="isLoading" @click="save">Save</ui-button>
                <ui-button v-show="selected && selected.id" :disabled="isLoading" @click="destroy" color="red">Remove</ui-button>
            </div>
        </ui-popover>
    </div>
</template>

<script>
    import DealerKit from '../../../api.ts'
    import useAuthorisedTeams from "../../../../ts/stores/team-store";

    export default {
        props: {
            isLoading: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            team: {},
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            id: {
                default() {
                    return Math.random();
                }
            }
        },
        watch: {
            team: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.selected = (newVal === null ? {} : newVal);
                    }
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: {},
                teams: [],
            }
        },
        mounted() {
            const { authorizedTeams } = useAuthorisedTeams()

            this.teams = authorizedTeams

            if (this.team) {
                this.selected = this.team
            }
        },
        methods: {
            save() {
                this.$emit('save', Object.assign({}, this.selected));
            },
            destroy() {
                this.$emit('save', new TeamSchema());
            },
            reset() {
                this.$refs['assignPopover'].close();
            },
            show() {
                this.$refs.assignPopover.open()
            }
        }
    }
</script>